<template>
	<section class="member-invoices">
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<span>发票管理</span>
				<el-button
					style="float: right"
					type="primary"
					size="mini"
					icon="el-icon-plus"
				>
					申请发票
				</el-button>
			</div>
			<el-table :data="invoices" size="small">
				<el-table-column prop="title" label="抬头" min-width="200" />
				<el-table-column prop="type" label="类型" width="120" />
				<el-table-column prop="amount" label="金额" width="120" />
				<el-table-column prop="status" label="状态" width="120">
					<template slot-scope="{ row }">
						<el-tag size="mini" :type="statusColor(row.status)">
							{{ row.status }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="date" label="申请时间" width="160" />
				<el-table-column label="操作" width="140">
					<template>
						<el-button type="text" size="mini">
							下载
						</el-button>
						<el-button type="text" size="mini">
							作废
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="!invoices.length" class="member-placeholder">
				暂无发票记录
			</div>
		</el-card>
	</section>
</template>

<script>
export default {
	name: 'MemberInvoices',
	props: {
		invoices: {
			type: Array,
			default: () => []
		}
	},
	methods: {
		statusColor(status) {
			const map = {
				开具中: 'warning',
				已开具: 'success',
				已寄出: 'success',
				已作废: 'info'
			}
			return map[status] || 'info'
		}
	}
}
</script>

